import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'services',
    loadChildren: () => import('./servicesCS/services.module').then(m => m.ServicesModule),
  },
  {
    path: 'career',
    loadChildren: () => import('./career/career.module').then(m => m.CareerModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
